/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Hear_RecommendationInputs */

const en_onboarding_hear_recommendation = /** @type {(inputs: Onboarding_Hear_RecommendationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommendation`)
};

const es_onboarding_hear_recommendation = /** @type {(inputs: Onboarding_Hear_RecommendationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendación`)
};

/**
* | output |
* | --- |
* | "Recommendation" |
*
* @param {Onboarding_Hear_RecommendationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_hear_recommendation = /** @type {((inputs?: Onboarding_Hear_RecommendationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Hear_RecommendationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_hear_recommendation(inputs)
	return en_onboarding_hear_recommendation(inputs)
});